import { render, staticRenderFns } from "./workshopdetailsTest.vue?vue&type=template&id=df4b7c7a&"
import script from "./workshopdetailsTest.vue?vue&type=script&lang=js&"
export * from "./workshopdetailsTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports